import {
  Button,
  Checkbox,
  Col,
  Form,
  Row,
  Space,
  Spin,
  Typography,
} from 'antd';

import {
  useDublicateClientsSettings,
  useDublicateClientsSettingsEffects,
} from '@pages/DublicateClientsSettings/hooks';
import type { DublicateClientsSettingsModel } from '@pages/DublicateClientsSettings/types';

const { Title } = Typography;

export const DublicateClientsSettingsPage = () => {
  const {
    getDublicateClientsSettings,
    saveDublicateClientsSettings,
    saveAndSearchDublicateClientsSettings,
    isSaving,
    isLoading,
    form,
  } = useDublicateClientsSettings();

  useDublicateClientsSettingsEffects({ getDublicateClientsSettings });

  return (
    <Spin spinning={isLoading || isSaving}>
      <Title level={4} style={{ marginTop: 0 }}>
        Критерии поиска клиента:
      </Title>
      <Form<DublicateClientsSettingsModel> form={form} layout="vertical">
        <Row gutter={[48, 24]}>
          <Col xs={24} md={12}>
            <Space direction="vertical" size={16}>
              <Checkbox
                checked={form.getFieldValue('SearchByFullName')}
                onChange={(e) =>
                  form.setFieldValue('SearchByFullName', e.target.checked)
                }
              >
                Фамилия Имя Отчество
              </Checkbox>

              <Checkbox
                checked={form.getFieldValue('SearchByMainPhone')}
                onChange={(e) =>
                  form.setFieldValue('SearchByMainPhone', e.target.checked)
                }
              >
                Телефон (основной)
              </Checkbox>

              <Checkbox
                checked={form.getFieldValue('SearchByEmail')}
                onChange={(e) =>
                  form.setFieldValue('SearchByEmail', e.target.checked)
                }
              >
                Email
              </Checkbox>
            </Space>
          </Col>

          <Col xs={24} md={12}>
            <Space direction="vertical" size={16}>
              <Checkbox
                checked={form.getFieldValue('SearchByInstagram')}
                onChange={(e) =>
                  form.setFieldValue('SearchByInstagram', e.target.checked)
                }
              >
                Instagram
              </Checkbox>

              <Checkbox
                checked={form.getFieldValue('SearchByTelegram')}
                onChange={(e) =>
                  form.setFieldValue('SearchByTelegram', e.target.checked)
                }
              >
                Telegram
              </Checkbox>

              <Checkbox
                checked={form.getFieldValue('SearchByVk')}
                onChange={(e) =>
                  form.setFieldValue('SearchByVk', e.target.checked)
                }
              >
                Вконтакте
              </Checkbox>
            </Space>
          </Col>
        </Row>

        <div style={{ marginTop: 32 }}>
          <Title level={4}>Автоматика:</Title>

          <Space direction="vertical" size={16}>
            <Checkbox
              checked={form.getFieldValue('BackgroundDuplicatesSearch')}
              onChange={(e) =>
                form.setFieldValue(
                  'BackgroundDuplicatesSearch',
                  e.target.checked
                )
              }
            >
              Фоновый поиск дубликатов
            </Checkbox>

            <Checkbox
              checked={form.getFieldValue('AutoMergeWithoutConflicts')}
              onChange={(e) =>
                form.setFieldValue(
                  'AutoMergeWithoutConflicts',
                  e.target.checked
                )
              }
            >
              Автоматическое объединение клиентов (при отсутствии конфликтов
              данных)
            </Checkbox>
          </Space>
        </div>

        <div style={{ marginTop: 32 }}>
          <Space size={16} wrap>
            <Button
              type="primary"
              size="large"
              onClick={saveDublicateClientsSettings}
              htmlType="button"
              style={{ width: 200 }}
            >
              Сохранить
            </Button>
            <Button
              size="large"
              onClick={saveAndSearchDublicateClientsSettings}
              htmlType="button"
              style={{ width: 200 }}
            >
              Сохранить и найти
            </Button>
          </Space>
        </div>
      </Form>
    </Spin>
  );
};
